import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Input, Form, Carousel } from "antd";
import Banner1 from "../../../src/assets/images/company-01.webp";
import BannerWork from "../../../src/assets/images/work-01.webp";
import axios from "axios";
import { Footer } from "../footer";
import { Header } from "../header";
import "./home.css"
import { baseUrl } from "../../../src/config"
import TextArea from "antd/es/input/TextArea";
import Image1 from "../../../src/assets/images/slider1.webp"
import Image2 from "../../../src/assets/images/slider2.webp";
import Image3 from "../../../src/assets/images/slider3.webp";
import Image4 from "../../../src/assets/images/slider4.webp";
import mImage1 from "../../../src/assets/images/mSlider1.webp"
import mImage2 from "../../../src/assets/images/mSlider2.webp";
import mImage3 from "../../../src/assets/images/3.webp";
import mImage4 from "../../../src/assets/images/4.webp";
import { useNavigate } from "react-router-dom";
import { WhatsappIcon } from "../overlay/whatsapp";
import UpAnimation from "../../../src/components/UpAnimation";
import LeftRightAnimation from "../../../src/components/LeftRightAnimation"
export const Home = () => {
  const [reviews, setReviews] = useState([]);
  const contactRef = useRef(null)
  const [carouselImages, setCarouselImages] = useState([]);

  const navigate = useNavigate()

  const [inputReq, setInputReq] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "", description: ""
  })
  const headerRef: any = useRef();

  useEffect(() => {
    if (window.innerWidth < 1000) {
      setCarouselImages([mImage1, mImage2, mImage3, mImage4])
    } else {
      setCarouselImages([Image1, Image2, Image3, Image4])
    }
    getReviews(); // Call getReviews when component mounts
    document.addEventListener('DOMContentLoaded', () => {
      const img = document.querySelector('.image');

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            img.classList.add('reveal');
            observer.unobserve(entry.target); // stop observing after animation
          }
        },
        {
          threshold: 0.3, // adjust as needed
        }
      );

      const imageContainer = document.querySelector('#imageSection');
      observer.observe(imageContainer);
    });

    headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, [])




  const getReviews = async () => {
    try {
      const resp = await axios.get(`${baseUrl}reviews`); // Assuming your API endpoint is 'reviews'
      console.log(resp.data); // Log the response to check
      setReviews(resp.data);
    } catch (e) {
      console.error(e);
    }
  };

  const [form] = Form.useForm();




  const handleSubmit = async () => {
    // Check if all fields in formData are filled
    const allFieldsFilled = Object.values(inputReq).every(value => {
      // Only trim if the value is a string
      return typeof value === 'string' ? value.trim() !== "" : value !== undefined && value !== null;
    });

    if (allFieldsFilled) {
      // If all fields are filled, log the form data and close the modal
      try {
        const resp = await axios.post(
          `${baseUrl}enquiry/add`, inputReq
        );
        if (resp?.data) {
          setInputReq({
            name: "",
            mobile: "",
            email: "",
            subject: "", description: ""
          })
          message.success("Team will get back to you soon")
        }
      } catch (e) {
        console.error(e);
      }

    } else {
      // If any field is empty, show a warning message
      message.error("Please fill in all fields before submitting.");
    }
  };


  return (
  <div className="home-container" ref={headerRef} style={{ position: "relative" }}>
    <Header />

   <div style={{ width: "100%", position: "relative" }}>
  {/* Carousel */}
  {carouselImages?.length > 0 && (
    <Carousel autoplay autoplaySpeed={1000}>
      {carouselImages.map((i, index) => (
        <div
          key={index}
          style={{
            width: "100%",
            height: 600,
            position: "relative",
            overflow: "hidden"
          }}
        >
          <img
            src={i}
            alt={`carousel-${index}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
          {/* Shadow effect at the bottom of each image */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "120px",
              background: "linear-gradient(to top, #27397515, transparent)",
              zIndex: 1,
              pointerEvents: "none"
            }}
          />
        </div>
      ))}
    </Carousel>
  )}

  {/* ✅ Responsive Quote Text */}
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 10,
      color: "#ffffff",
      fontWeight: "bold",
      textAlign: "center",
      textShadow: "2px 2px 6px #273975",
      padding: "0 20px 60px", // 60px bottom padding to stay above button
      maxWidth: "90%",
      fontSize: "clamp(30px, 7vw, 58px)", // responsive font size
      lineHeight: "1.3"
    }}
  >
    Empowering Global Trade,<br /> Building Trusted Connections
  </div>

  {/* TALK TO US Button */}
  <div
    style={{
      position: "absolute",
      bottom: 17,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10
    }}
  >
    <Button
      style={{
        backgroundColor: "#273975",
        color: "#fff",
        fontWeight: "bold",
        border: "none",
        padding: "12px 28px",
        borderRadius: "6px",
        fontSize: "16px"
      }}
      className="home-header-button"
      onClick={() => {
        contactRef?.current?.scrollIntoView({ behavior: "smooth" });
      }}
    >
      TALK TO US
    </Button>
  </div>
</div>

  

      <div className="quotes-section">
        <UpAnimation>
        <div className="quotes-section-title">Connecting Markets, Cultures, and <span className="highlight-text">Opportunities</span></div>
        </UpAnimation>
        <div
          className="quotes-container"
        >
          <div style={{ width: "100%" }} >

            <img style={{ width: "100%" }} src={Banner1} className="image"></img>
          </div>
          <div className="quotes-left-content">
            <LeftRightAnimation>
            <div className="subtitle">
              Global Commerce Experts Driven by {" "}
              <span style={{ color: "#273975" }}> Insight, Commitment, and Trust</span>
            </div>
            </LeftRightAnimation>
            <div className="text">
                We specialize in facilitating seamless international trade by connecting businesses across borders. With a deep understanding of global markets and a strong network of suppliers and distributors, we help companies navigate the complex landscape of import and export operations.Our expertise covers a wide range of products and industries, and our tailored solutions are designed to meet the unique demands of each client.
            </div>
            <div style={{ marginTop: 20 }}>
              <Button
                className="btn-why-thy"
                onClick={() => navigate("/about_us")}
              >
                ABOUT US
              </Button>
            </div>
          </div>
          {/* <div style={{ width: "100%" }} >

            <img style={{ width: "100%" }} src={Banner1} className="image"></img>
          </div> */}
        </div>
      </div>
       <div className="carousel-section">
        <UpAnimation>
        <div className="carousel-section-title">Trusted By Our <span className="highlight-text">Clients!!</span>
        </div>
        </UpAnimation>
        {reviews?.length > 0 && <Carousel arrows autoplay autoplaySpeed={2000} >
  {reviews?.map((r, index) => (
    <div key={index} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px", background: "red" }}>
      <div style={{ backgroundColor: "#dddfe3", padding: "20px", color: "#000000", display: "flex", justifyContent: "center", width: "80%" }}>
        <div style={{ fontSize: 18, width: 170, height: 170, borderRadius: 100, background: "#FFF", overflow: "hidden" }}>
          {r?.profile && <img style={{ width: "100%", height: "100%" }} src={r?.profile} alt="profile" />}
        </div>
      </div>
      
      <div style={{ backgroundColor: "#dddfe3", color: "#000000", width: "80%", padding: "20px 20px 10px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 24, fontWeight: "bold" }}>{r?.name}</div>
        {/* 5 stars */}
        <div style={{ fontSize: 20, color: "#FFD700"}}>★★★★★</div>
      </div>
      
      <div style={{ backgroundColor: "#dddfe3", padding: "0px 20px 20px 20px", color: "#000000", marginBottom: 20, width: "80%", textAlign: "center" }}>
        <div style={{ fontSize: 18 }}>{r?.review}</div>
      </div>
    </div>
  ))}
</Carousel>}

      </div>
      <div className="work-section">
         <UpAnimation>
        <div className="work-header">Comprehensive Global Trade Solutions for <span className="highlight-text">Every Need</span>
        </div>
        </UpAnimation>
        <div className="work-body">
          <div style={{ width: "100%" }}>
            <img style={{ width: "100%" }} src={BannerWork}></img>
          </div>
          <div className="work-content">
            <LeftRightAnimation>
            <div className="work-title">
              Comprehensive Product Import Solutions for <span className="highlight-text">Diverse Market Needs</span>
            </div>
            </LeftRightAnimation>
            <div className="work-description">
               You are in one-stop solution for top-quality power, engineering, and machinery needs. We specialize in providing reliable diesel generators that ensure uninterrupted power supply for your business and industrial projects. Our extensive range of engineering products and precision components guarantees exceptional performance, durability, and accuracy for various applications. Additionally, we offer robust construction machinery designed to enhance efficiency and productivity on-site, along with advanced agricultural machinery to support modern farming practices. Explore our offerings to find the perfect solutions tailored to your needs, backed by quality, innovation, and expert support. 
            </div>
            <div className="work=button">
              <Button className="why-thy-button" onClick={() => navigate("/products")}>EXPLORE OUR PRODUCTS</Button>
            </div>
          </div>

        </div>
      </div>
      {/* <div className="image-section">
        <div className="image-section-title">At Thy, we don’t just promise quality—<span style={{ color: "#273975" }}>we deliver it :</span></div>
        <div className="image-section-div">
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "50%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,marginBottom:10,color:"#273975"}}>Industry Leader</div>
            <div>From humble beginnings to industry leader, Thy has built innovative design and printing
solutions. With 15 years of experience, we provide high-quality, tailored design and printing
services to meet the diverse needs of all.</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,color:"#273975"}}>Creative at scale</div>
            <div style={{fontSize:30,fontWeight:500,color:"#000000"}}>3x</div>
            <div style={{fontSize:16,fontWeight:"lighter",color:"#767676"}}>Faster delivery of designs</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,color:"#273975"}}>Years of Excellence</div>
            <div style={{fontSize:30,fontWeight:500,color:"#000000"}}>15 +</div>
            <div style={{fontSize:16,fontWeight:"lighter",color:"#767676"}}>Proven Success</div>
          </div>
        </div>
        <div className="image-section-div">
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
          <div style={{fontSize:24,fontWeight:500,color:"#273975"}}>Project Milestones</div>
            <div style={{fontSize:30,fontWeight:500,color:"#000000"}}> 2035 +</div>
            <div style={{fontSize:16,fontWeight:"lighter",color:"#767676"}}>On Time, Every Time</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
          <div style={{fontSize:24,fontWeight:500,color:"#273975"}}>Client Support</div>
            <div style={{fontSize:30,fontWeight:500,color:"#000000"}}>100%</div>
            <div style={{fontSize:16,fontWeight:"lighter",color:"#767676"}}>Instant Response</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "50%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,marginBottom:10,color:"#273975"}}>Passion Meets Delivery</div>
            <div style={{fontSize:16,fontWeight:"lighter"}}>We’ve completed 2035+ projects, delivering solutions with quality, creativity, and care. Our commitment to excellence ensures each project leaves a lasting impact, building trust, satisfaction, and meaningful connections.</div>
          </div>

        </div>
      </div>  */}
      <UpAnimation>
      <div className="contact-title">Ask to our <span className="highlight-text">Expert!</span></div>
      </UpAnimation>
      <div className="contact-form" ref={contactRef} style={{ width: window.innerWidth < 1000 ? "80%" : 500 }}>
        <div style={{ fontSize: 28 }}>Contact Us</div>
        <div className="contact-group">
          <div>Name</div>
          <div><Input value={inputReq.name} onChange={(e) => setInputReq({ ...inputReq, name: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div>Phone</div>
          <div><Input value={inputReq.mobile} onChange={(e) => setInputReq({ ...inputReq, mobile: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div>Email</div>
          <div><Input value={inputReq.email} onChange={(e) => setInputReq({ ...inputReq, email: e.target.value })}></Input ></div>
        </div>
        <div className="contact-group">
          <div>Subject</div>
          <div><Input value={inputReq.subject} onChange={(e) => setInputReq({ ...inputReq, subject: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div >Description</div>
          <div><TextArea value={inputReq.description} style={{ width: "183px" }} onChange={(e) => setInputReq({ ...inputReq, description: e.target.value })}></TextArea></div>
        </div>
        <Button style={{ width: "80%", background: "#273975", borderRadius: 12, border: "1px solid #273975", color: "#000000", fontWeight: 600, fontSize: 20 }}
          onClick={handleSubmit}>Submit</Button>
      </div>
       <WhatsappIcon/>
      <Footer />

    </div>
  );
};